export const dataDropzone = {
    dropzone: {
        textDropzone: 'Arrastra y suelta el archivo aquí',
        textDropzoneError: 'Archivo no válido:  ',
        textDropzoneSuccess: 'Archivo válido:  ',
        textCurrentFile: 'Archivo actual:  ',
    },
}
